'use client';
import React, { FC, useRef } from 'react';
import { Label } from '@/components/client/Label/Label';
import { useModalContext } from '@/context/ModalsContext';
// import { motion, useInView } from 'framer-motion';

interface IProps {
  label: string;
  title: string;
  description: string;
  withContactButton?: boolean;
}

export const MainSection: FC<IProps> = ({
  label,
  title,
  description,
  withContactButton,
}) => {
  const ref = useRef(null);
  const { setIsModalOpened } = useModalContext();
  // const isInView = useInView(ref, { once: true });
  const titleWithNbsp = title.replace(/&nbsp;/g, '\u00A0');

  return (
    <div className="flex flex-col items-center justify-center" ref={ref}>
      <Label label={label} />
      <h1
        className="mb-6 mt-14 text-[24px] font-semibold md:text-7xl"
        // initial={{ opacity: 0, y: 20 }}
        // animate={isInView ? { opacity: 1, y: 0 } : {}}
        // transition={{ duration: 0.5 }}
      >
        {titleWithNbsp}
      </h1>
      {description && (
        <p
          className="description-with-links text-lg"
          // initial={{ opacity: 0, y: 20 }}
          // animate={isInView ? { opacity: 1, y: 0 } : {}}
          // transition={{ duration: 0.5, delay: 0.2 }}
          style={{ maxWidth: '750px', margin: '0 auto' }}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {withContactButton && (
        <button
          onClick={() => setIsModalOpened(true)}
          className="ring-offset-background focus-visible:ring-ring mt-8 flex h-10 items-center justify-center whitespace-nowrap rounded-md bg-black px-5 py-6 text-lg font-medium text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
        >
          Contact Us
        </button>
      )}
    </div>
  );
};
